import { type DeviceSettings } from "@ca.vmedia.tv/domains";
import { useNuxtApp } from '#app';
import type { ExposeInterface } from './types';
import type { AxiosError } from 'axios';
import { Logger } from '@/utils';

export const useDeviceSettingsStore = defineStore('DeviceSettings', (): ExposeInterface => {
    const { $domains } = useNuxtApp();
    const settings: Ref<DeviceSettings | null> = ref(null);

    const getterSettings = computed((): DeviceSettings | null => {
        return settings.value; 
    });

    const setupSettings = async (): Promise<void> => {
        try {
            settings.value = await $domains.clientRepository.getDeviceSettings();
        } catch (error) {
            Logger.captureError(error as AxiosError | Error);
        }
    };

    return { 
        getterSettings,
        setupSettings,
    };
});